export function getApiBaseUrl(): string {
  // Priorizar variável de ambiente se existir
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }

  // Em desenvolvimento, apontar diretamente para o backend local
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:8093/api/portal';
  }

  // Em produção, usar a URL configurada ou construir dinamicamente
  const protocol = window.location.protocol;
  const host = window.location.hostname;
  const port = host === "localhost" ? ":8093" : "";
  return `${protocol}//${host}${port}/api/portal`;
}
